export const HelpMenu = [
  { label: 'Merge accounts', href: `${process.env.PUBLIC_URL}/help/merge-accounts.pdf`, tracking: "Merge-users-and-classes-from-one-account-to-another"},
  { label: 'Move user to another account', href: `${process.env.PUBLIC_URL}/help/move-user.pdf`, tracking: "Move-a-user-to-another-account" },
]